import { Case } from 'services';
export const CaseImageJsonTestMock: Case[] = [
  {
    id: 'CIJT-001',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'ImageJsonTest',
      subjectValue:
        '{"output":[{"type": "imageUrl", "value": {"caption":"Header Sample Header imageUrl", "value": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Xbox_logo_%282019%29.svg/1024px-Xbox_logo_%282019%29.svg.png"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CIJT-002',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'ImageJsonTest',
      subjectValue:
        '{"output":[{"type": "imageBytes", "value": {"caption":"Header Sample Header imageBytes", "value": "iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CIJT-003',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'ImageJsonTest',
      subjectValue:
        '{"output":[{"type": "imageCarousel", "value": [{"type": "imageUrl", "value": {"caption":"Header Sample Header imageUrl", "value": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Xbox_logo_%282019%29.svg/1024px-Xbox_logo_%282019%29.svg.png"}}, {"type": "imageBytes", "value": {"caption":"Header Sample Header imageBytes", "value": "iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="}}]},{"type": "hr"}, {"type":"sectionHeader","value":"Description"},{"type":"text","value":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut sit amet dui consequat, finibus urna quis, posuere enim. Pellentesque sed tristique sem. Pellentesque ultricies ullamcorper ligula at ultrices. Sed elementum vehicula tempus. Mauris posuere."}]}',

      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CIJT-004',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'ImageJsonTest',
      subjectValue:
        '{"output":[{"type": "imageBytes", "value": {"caption":"Header Sample Header imageBytes", "value": "iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="}},{"type": "hr"},{"type": "imageUrl", "value": {"caption":"Header Sample Header imageUrl", "value": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Xbox_logo_%282019%29.svg/1024px-Xbox_logo_%282019%29.svg.png"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CIJT-005',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'ImageJsonTest',
      subjectValue:
        '{"output":[{"type": "imageBytes", "value": {"caption":"Header Sample Header imageBytes", "value": "iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="}},{"type": "hr"},{"type": "imageUrl", "value": {"caption":"Header Sample Header imageUrl", "value": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Xbox_logo_%282019%29.svg/1024px-Xbox_logo_%282019%29.svg.png"}},{"type": "hr"},{"type":"headerValue","value":{"header":"Custom vehicle name","value":"Yellow Rose"}},{"type": "hr"},{"type":"header","value":"Vehicle description"},{"type":"text","value":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut sit amet dui consequat, finibus urna quis, posuere enim. Pellentesque sed tristique sem. Pellentesque ultricies ullamcorper ligula at ultrices. Sed elementum vehicula tempus. Mauris posuere."}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  }
];
